<template>
  <base-modal :visible="visible" @update:visible="close">
    <div class="card-content">
      <div class="product-info">
        <van-image class="image" :src="goodsInfo.mobileBanner" />
        <div class="info-info">
          <p class="product-name el2">{{goodsInfo.name}}</p>
          <p class="el2">{{goodsInfo.applyTo}}</p>
        </div>
      </div>
    </div>
    <p class="tips" v-show="timeIntervalList.length">*所有时段选择均为船上时间，请根据船上提示调整您的时区避免错过活动</p>
    <div :class="['card-content', {'padding-bottom': !goodsInfo.needSync}]" style="padding-top:0">
      <!-- 预订时间段 -->
      <date-picker
        v-for="(item, index) in timeIntervalList"
        :ref="`refDatePicker${index}`"
        :key="item.timeslot"
        :initData="{...item, index}"
        :initChoosed="timeIntervalSelected[index]"
        @stockChange="stockChange" />
      <div class="field-title">数量</div>
      <div class="number-box">
        <van-stepper v-model="goodsNumber" input-width="50" :min="goodsNumberMin" :disabled="goodsNumberDisabled" />
        <span class="stock">剩余：{{stock}}</span>
      </div>
      <!-- 选择乘客 -->
      <choose-customer
        ref="chooseCustomer"
        v-show="goodsInfo.needSync"
        :goodsInfo="goodsInfo"
        @customerChange="customerChange"
      />
    </div>
    <div class="btn-box">
      <div class="btn-item" @click="close">取消</div>
      <div class="btn-item btn-booking" @click="handleSubmit">确认</div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
import BookingDatePicker from './dialog_booking/BookingDatePicker'
import BookingChooseCustomer from './dialog_booking/BookingChooseCustomer'
import api from '@/api'
import { showLoading, hideLoading, showAlert, showToast } from '@/utils/tools'
import dayjs from 'dayjs'
import uniq from 'lodash/uniq'
import { getShoppingCartNum, bindGioTrack } from '@/plugins/common'

export default {
  name: 'DialogBooking',

  props: {
    visible: Boolean,
    goodsInfo: Object
  },

  components: {
    BaseModal,
    'date-picker': BookingDatePicker,
    'choose-customer': BookingChooseCustomer
  },

  data () {
    return {
      goodsNumber: 1,
      goodsNumberMin: 1,
      goodsNumberDisabled: false,
      stock: 0,
      timeIntervalList: [],
      timeIntervalSelected: [],
      isPackageProduct: false
    }
  },

  watch: {
    visible (newVal) {
      this.goodsNumber = this.goodsInfo && this.goodsInfo.needSync ? 0 : 1
      this.goodsNumberMin = this.goodsInfo && this.goodsInfo.needSync ? 0 : 1
      this.goodsNumberDisabled = this.goodsInfo && this.goodsInfo.needSync
      this.stock = 0
      this.timeIntervalList = []
      this.timeIntervalSelected = []
      if (newVal && this.goodsInfo.id && this.$store.state.bindTicket) this.getPackageProducts()
    }
  },

  computed: {
    isEdit () {
      return Boolean(this.goodsInfo.shoppingCartId)
    }
  },

  methods: {
    async handleSubmit () {
      const { customerChoosed, customerList } = this.$refs.chooseCustomer
      const { needSync, id, shoppingCartId } = this.goodsInfo
      if (needSync && !customerChoosed.length) return showToast('请选择乘客')
      if (this.isPackageProduct && this.checkPackageTimeSlotRepeat()) return showToast('您的活动时间有冲突，请重新选择')
      const customerChoosedFormat = [].concat.apply([], customerList.map(x => x.bookingGuests)).filter(x => customerChoosed.indexOf(x.id) >= 0)
      let addProductItems = []
      if (needSync) {
        if (this.isPackageProduct) {
          for (let i = 0; i < this.timeIntervalSelected.length; i++) {
            const { productId, shipDate = '', timeslot = -1 } = this.timeIntervalSelected[i]
            addProductItems = addProductItems.concat(customerChoosedFormat.map(x => ({
              bookingRecordId: x.bookingRecord_Id || x.bookingRecordId,
              number: 1,
              guestRecordId: x.id,
              shipDate,
              timeslot,
              productId,
              itemType: 0
            })))
          }
        } else {
          addProductItems = customerChoosedFormat.map(x => ({
            bookingRecordId: x.bookingRecord_Id || x.bookingRecordId,
            number: 1,
            guestRecordId: x.id,
            shipDate: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].shipDate : '',
            timeslot: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].timeslot : -1,
            productId: id,
            itemType: 0
          }))
        }
      } else {
        addProductItems = addProductItems.concat({
          bookingRecordId: 0,
          number: this.goodsNumber,
          guestRecordId: 0,
          shipDate: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].shipDate : '',
          timeslot: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].timeslot : -1,
          productId: id,
          itemType: 0
        })
      }
      showLoading('提交中...')
      const params = {
        productId: id,
        number: this.goodsNumber,
        addProductItems
      }
      const { errCode, errMsg } = this.isEdit ? await api.editProduct({
        shoppingCartId,
        addProduct: params
      }) : await api.addProduct(params)
      if (errCode === 0) await getShoppingCartNum()
      hideLoading()
      if (errCode === 0) {
        showToast.success(this.isEdit ? '修改成功' : '添加成功')
        this.$emit('submitSuccess')
        this.close()
        bindGioTrack({
          productName: this.goodsInfo.name,
          productCategory: this.goodsInfo.categoryName || '',
          productId: id
        })
      } else {
        showAlert(errMsg || '提交失败，请稍后重试')
      }
    },
    checkPackageTimeSlotRepeat () {
      if (this.timeIntervalList.length === 1) return false
      const shipDateChoosedAll = this.timeIntervalList.map((x, i) => {
        const { shipDateChoosed, shipDateColumns } = this.$refs[`refDatePicker${i}`][0]
        return shipDateColumns[shipDateChoosed]
      })
      const shipDateRepeat = uniq(shipDateChoosedAll.filter(x => shipDateChoosedAll.filter(j => j === x).length > 1))
      if (!shipDateRepeat.length) return false
      let repeatAll = []
      shipDateRepeat.forEach(shipDateItem => {
        const choosedAll = []
        this.timeIntervalList.forEach((x, i) => {
          const { shipDateChoosed, shipDateColumns, timeSlotChoosed, timeSlotColumns } = this.$refs[`refDatePicker${i}`][0]
          const [start, end] = timeSlotColumns[timeSlotChoosed].split('-')
          const startSplit = start.split(':')
          const endSplit = end.split(':')
          if (shipDateItem === shipDateColumns[shipDateChoosed]) choosedAll.push([Number(`${startSplit[0]}${startSplit[1]}`), Number(`${endSplit[0]}${endSplit[1]}`)])
        })
        const timeSlotRepeat = choosedAll.filter((x, i) => choosedAll.filter((y, j) => i !== j && !(y[1] < x[0] || x[1] < y[0])).length)
        repeatAll = repeatAll.concat(timeSlotRepeat)
      })
      return Boolean(repeatAll.length)
    },
    customerChange (num) {
      this.goodsNumber = num
    },
    stockChange ({ index, stock, shipDate, timeslot }) {
      this.timeIntervalSelected[index].shipDate = shipDate
      this.timeIntervalSelected[index].timeslot = timeslot
      this.stock = stock
    },
    async getPackageProducts () {
      showLoading()
      const { errCode, errMsg, data } = await api.getPackageProducts({
        productId: this.goodsInfo.id,
        sailDate: dayjs(this.$store.state.bindTicket.sailDate).format('YYYY-MM-DD')
      })
      hideLoading()
      if (errCode === 0) {
        const { normalProductInvs, packageProductItemInvs, currentInv } = data
        this.isPackageProduct = Boolean(packageProductItemInvs && packageProductItemInvs.length)
        // 产品数量初始化
        if (this.goodsInfo.initBookingGuestsChoosed && this.goodsInfo.initBookingGuestsChoosed.length) {
          this.goodsNumber = this.goodsInfo.initBookingGuestsChoosed.length
        } else if (this.goodsInfo.name.indexOf('尊享服务') >= 0) {
          this.goodsNumber = this.$store.state.bindTicket.bookingGuests.length
        } else {
          this.goodsNumber = this.goodsInfo.qty || (this.goodsInfo.needSync ? 0 : 1)
        }
        // 普通产品
        if (normalProductInvs && normalProductInvs.length) {
          if (normalProductInvs.length === 1 && normalProductInvs[0].shipDate === '1753-01-01') {
            this.stock = normalProductInvs[0].currentInv
          } else {
            const shipDates = uniq(normalProductInvs.map(x => x.shipDate))
            const timeIntervalList = [{
              title: '预订时间段',
              shipDates: shipDates.map(x => ({
                shipDate: x,
                timeSlotList: normalProductInvs.filter(j => j.shipDate === x)
              }))
            }]
            const { currentInv, shipDate, timeslot } = timeIntervalList[0].shipDates[0].timeSlotList[0]
            this.stock = currentInv
            this.timeIntervalSelected = [this.goodsInfo.shipDate && this.goodsInfo.timeSlot ? {
              shipDate: this.goodsInfo.shipDate,
              timeslot: this.goodsInfo.timeSlot
            } : {
              shipDate,
              timeslot
            }]
            this.timeIntervalList = timeIntervalList
          }
        }
        // 打包产品
        if (packageProductItemInvs && packageProductItemInvs.length) {
          const timeIntervalList = []
          const timeIntervalSelected = []
          this.stock = currentInv
          for (let i = 0; i < packageProductItemInvs.length; i++) {
            const packageInvViews = packageProductItemInvs[i].packageInvViews
            const shipDates = uniq(packageInvViews.map(x => x.shipDate))
            timeIntervalList.push({
              title: packageProductItemInvs[i].productName,
              noTimeslot: shipDates[0] === '1753-01-01',
              shipDates: shipDates.map(x => ({
                shipDate: x,
                timeSlotList: packageInvViews.filter(j => j.shipDate === x)
              }))
            })
            timeIntervalSelected.push({
              productId: packageProductItemInvs[i].productId,
              shipDate: packageInvViews[0].shipDate,
              timeslot: packageInvViews[0].timeslot
            })
          }
          this.timeIntervalList = timeIntervalList
          this.timeIntervalSelected = this.goodsInfo.packageItems ? this.goodsInfo.packageItems.map(x => ({
            productId: x.productId,
            shipDate: x.shipDate,
            timeslot: x.timeSlot
          })) : timeIntervalSelected
        }
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    },
    close () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.card-content {
  padding: 30px;
  padding-bottom: 0;
  &.padding-bottom {
    padding-bottom: 16px;
  }
  ::v-deep .field-title {
    margin-top: 28px;
    font-size: 24px;
    color: #000;
    line-height: 40px;
  }
}
.product-info {
  display: flex;
  .image {
    flex: none;
    width: 226px;
    margin-right: 28px;
  }
  .info-info {
    max-width: 3.3rem;
    font-size: 24px;
    color: #666;
    .product-name {
      font-size: 30px;
      color: #333;
      line-height: 52px;
    }
  }
}
.tips {
  margin-top: 30px;
  padding: 26px 30px;
  font-size: 18px;
  color: #333;
  line-height: 26px;
  background-color: #e8ecef;
}
.number-box {
  display: flex;
  align-items: center;
  height: 76px;
  .stock {
    margin-left: 30px;
    font-size: 24px;
    color: #999;
  }
}
.btn-box {
  display: flex;
  border-top: 1Px solid #eaeaea;
  font-size: 30px;
  color: #999;
  text-align: center;
  .btn-item {
    flex: none;
    width: 50%;
    line-height: 98px;
    &.btn-booking {
      .btn-linear-gradient;
      color: #333;
    }
  }
}
</style>
